module.exports = __webpack_public_path__ + "static/media/memoryroom.15f54816.png";